import { Component, Inject, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { DialogData } from "../yesnodialog/yesnodialog.component";
import { FlowNavigationService } from "src/app/Services/flow-navigation.service";

@Component({
  selector: "app-cancal-flow-dialog",
  templateUrl: "./cancal-flow-dialog.component.html",
  styleUrls: ["./cancal-flow-dialog.component.scss"],
})
export class CancalFlowDialogComponent implements OnInit {
  constructor(
    private router: Router,
    private flowNavigationService: FlowNavigationService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {}

  ngOnInit(): void {}

  leave() {
    this.flowNavigationService.navigateBack();
  }

  onNoClick() {
    this.router.navigate(["/create-guide"]);
    location.reload();
  }

  savedraft() {
    localStorage.setItem("create-flow-savedraft", "create-flow-call-savedraft");
    this.router.navigate(["/create-guide"]);
    location.reload();
  }
}
